module.exports = __webpack_public_path__ + "img/marker_four_yellow1.92893c4a.png";